import { render, staticRenderFns } from "./TrimEditor.vue?vue&type=template&id=825895ea&scoped=true"
import script from "./TrimEditor.vue?vue&type=script&lang=js"
export * from "./TrimEditor.vue?vue&type=script&lang=js"
import style0 from "./TrimEditor.vue?vue&type=style&index=0&id=825895ea&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "825895ea",
  null
  
)

export default component.exports